import PageBanner from '../components/PageBanner';
import './Properties.css';

export default function Properties() {
  return (
    <>
      <PageBanner 
        title="Properties" 
        subtitle="Discover Your Dream Property"
      />
      <section className="page-section">
        {/* Your properties content */}
      </section>
    </>
  );
}
